import { render, staticRenderFns } from "./MovieDetail.vue?vue&type=template&id=595c0456&scoped=true"
import script from "./MovieDetail.vue?vue&type=script&lang=js"
export * from "./MovieDetail.vue?vue&type=script&lang=js"
import style0 from "./MovieDetail.vue?vue&type=style&index=0&id=595c0456&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c0456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('595c0456')) {
      api.createRecord('595c0456', component.options)
    } else {
      api.reload('595c0456', component.options)
    }
    module.hot.accept("./MovieDetail.vue?vue&type=template&id=595c0456&scoped=true", function () {
      api.rerender('595c0456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/movieLists/MovieDetail.vue"
export default component.exports